var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCambioCarril(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-2 {\n        fill: url(#GradientFill_3-4);\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5 {\n        stroke-width: 0px;\n      }\n\n      .cls-3 {\n        fill: url(#GradientFill_3-2);\n      }\n\n      .cls-4 {\n        fill: url(#GradientFill_3-3);\n      }\n\n      .cls-5, .cls-6 {\n        fill: url(#GradientFill_3);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3",
    "data-name": "GradientFill 3",
    x1: 25.43,
    y1: -9.84,
    x2: 25.43,
    y2: -59.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa780c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#d1b24a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5d06a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M12.79-35.23c0-6.97,5.67-12.63,12.64-12.63s12.64,5.67,12.64,12.63-5.67,12.64-12.64,12.64-12.64-5.67-12.64-12.64M10.74-35.23c0,8.1,6.59,14.69,14.69,14.69s14.69-6.59,14.69-14.69-6.59-14.69-14.69-14.69-14.69,6.59-14.69,14.69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-2",
    "data-name": "GradientFill 3",
    x1: 25.5,
    x2: 25.5,
    xlinkHref: "#GradientFill_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-3",
    "data-name": "GradientFill 3",
    x1: 25,
    y1: 50.14,
    x2: 25,
    y2: 0.14,
    xlinkHref: "#GradientFill_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-4",
    "data-name": "GradientFill 3",
    x1: 25,
    y1: 50.14,
    x2: 25,
    y2: 0.17,
    xlinkHref: "#GradientFill_3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M12.79-35.23c0-6.97,5.67-12.63,12.64-12.63s12.64,5.67,12.64,12.63-5.67,12.64-12.64,12.64-12.64-5.67-12.64-12.64M10.74-35.23c0,8.1,6.59,14.69,14.69,14.69s14.69-6.59,14.69-14.69-6.59-14.69-14.69-14.69-14.69,6.59-14.69,14.69"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: -9.87,
    y: -65.36,
    width: 70.73,
    height: 70.73
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M25,3.06C12.9,3.06,3.06,12.9,3.06,25s9.84,21.94,21.94,21.94,21.94-9.84,21.94-21.94S37.1,3.06,25,3.06M25,50C11.22,50,0,38.78,0,25S11.22,0,25,0s25,11.21,25,25-11.22,25-25,25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.82,38.15c-.72,0-1.34-.26-1.86-.77s-.77-1.13-.77-1.86v-5.26h2.63v5.26h5.26v2.63h-5.26ZM11.19,19.74v-5.26c0-.72.26-1.34.77-1.86s1.13-.77,1.86-.77h5.26v2.63h-5.26v5.26h-2.63ZM23.02,34.07c-2.02-.31-3.74-1.17-5.16-2.6-1.42-1.42-2.29-3.14-2.6-5.16h2.63c.26,1.29.86,2.4,1.79,3.34s2.04,1.53,3.34,1.79v2.63ZM15.26,23.69c.31-2.02,1.17-3.74,2.6-5.18,1.42-1.44,3.14-2.3,5.16-2.58v2.63c-1.29.26-2.4.86-3.34,1.79s-1.53,2.04-1.79,3.34h-2.63ZM24.33,27.63c-.72,0-1.34-.26-1.86-.77s-.77-1.13-.77-1.86.26-1.37.77-1.87,1.13-.76,1.86-.76,1.37.25,1.87.76.76,1.13.76,1.87-.25,1.34-.76,1.86-1.13.77-1.87.77ZM30.78,23.69c-.26-1.29-.86-2.4-1.79-3.34s-2.04-1.53-3.34-1.79v-2.63c2.02.31,3.74,1.17,5.18,2.6,1.44,1.42,2.3,3.14,2.58,5.16h-2.63ZM34.85,19.74v-5.26h-5.26v-2.63h5.26c.72,0,1.34.26,1.86.77s.77,1.13.77,1.86v5.26h-2.63ZM26.96,38.15c-.24,0-.45-.06-.64-.18s-.35-.28-.48-.48c-.11-.2-.17-.41-.18-.64s.04-.45.15-.67l5.26-9.2c.13-.2.3-.36.51-.49s.43-.2.67-.2.46.06.66.18.35.29.46.51l5.26,9.2c.13.2.19.42.18.66s-.07.46-.18.66c-.13.2-.3.36-.49.48s-.42.18-.66.18h-10.52ZM32.22,36.83c.18,0,.33-.07.46-.2s.2-.28.2-.46-.07-.33-.2-.46-.28-.2-.46-.2-.33.07-.46.2-.2.28-.2.46.07.33.2.46.28.2.46.2ZM31.56,34.2h1.31v-5.26h-1.31v5.26Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCambioCarril);
export default __webpack_public_path__ + "static/media/Icon_CambioCarril.8216e5885af4b194e3985dd21e4216ad.svg";
export { ForwardRef as ReactComponent };